export default __webpack_public_path__ + "static/media/cashier.a2249c43.png";